//This file is automatically rebuilt by the Cesium build process.
export default "varying vec4 v_color;\n\
\n\
void main()\n\
{\n\
    gl_FragColor = czm_gammaCorrect(v_color);\n\
}\n\
";
